import useFetchObjects from "../../api/useFetchObjects";

const useUserPurchases = () => {
  return useFetchObjects(
    ["user-purchases"],
    "payments/purchase_history/?type=BOOK",
    localStorage.getItem("token"),
    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
      cacheTime: 30 * 60 * 1000, // Keep data in cache for 30 minutes
    },
  );
};

export default useUserPurchases;
